import React, { FC, useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import SettingsSidebar from '../components/SettingsSidebar'

import { FormInputRadio, PageLayout, SettingsSwitch } from 'Components'
import { CoreBackendUserReduxType, ReduxStoreState } from 'Models'
import { dietCriteriaOptions } from 'Pages/AnamnesisPage/steps/PersonalMenuPlanStep'
import {
  coreBackendUserSelector,
  fetchCoreBackendUserAction,
  updateCoreBackendUserAction
} from 'ReduxStore/coreBackendUser'
import { useAppDispatch, useAppSelector } from 'ReduxStore/hooks'
import { updateUserSettingsAction } from 'ReduxStore/userSettings'
import { Diet } from 'yup-schema/Schemas/anamnesis'

type SelectorProps = {
  coreBackendUser: CoreBackendUserReduxType
}

const mapStateToProps = createStructuredSelector<ReduxStoreState, SelectorProps>({
  coreBackendUser: coreBackendUserSelector
})

const mapDispatchToProps = {
  fetchCoreBackendUser: fetchCoreBackendUserAction
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

const MenuplanSettingsPage: FC<PropsFromRedux> = ({ fetchCoreBackendUser }: PropsFromRedux) => {
  const userDiet = useAppSelector(coreBackendUserSelector)?.diet
  const userSettings = useAppSelector((state) => state.userSettings)

  const dispatch = useAppDispatch()

  const toggleSetting = (setting: keyof typeof userSettings.data): void => {
    dispatch(updateUserSettingsAction({ [setting]: !userSettings.data[setting] }))
  }

  const handleDietSelection = (diet: Diet): void => {
    dispatch(updateCoreBackendUserAction({ diet }))
  }

  useEffect(() => {
    fetchCoreBackendUser()
  }, [])

  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SettingsSidebar />

          <div className="col-12 col-lg-8">
            <h1>Einstellungen</h1>

            <h2 className="mt-4 mb-3">Menüplan</h2>

            <div className="basiccard px-3 pt-5 pb-3 mb-2">
              <SettingsSwitch
                title="Menüplan im Tagebuch anzeigen"
                name="menuPlanHidden"
                value={!userSettings.data.menuPlanHidden}
                onValueChange={() => toggleSetting('menuPlanHidden')}
              />
            </div>

            <div className="basiccard p-3">
              <p>
                Was essen Sie grundsätzlich - und was nicht? Die Änderung der Ernährungsweise wird erst mit dem nächsten
                Menüplan in der kommenden Woche wirksam.
              </p>

              <div className="mt-4">
                <FormInputRadio
                  name="diet"
                  items={dietCriteriaOptions}
                  onChange={(diet) => handleDietSelection(diet.value)}
                  selectedKey={userDiet}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default connector(MenuplanSettingsPage)
